module.exports = __webpack_public_path__ + "img/tutorial-2a.6665e775.jpg";